// priceFromDiscount computes what a package costs at a percentage off the
// baseline. The result is authoritative once saved; nothing recomputes it.
export function priceFromDiscount(sessions: number, unitPence: number, percent: number): number {
  return Math.round((sessions * unitPence * (100 - percent)) / 100)
}

// discountFromPrice reports what discount a price represents, or null when
// there is no baseline to measure against.
export function discountFromPrice(sessions: number, unitPence: number, pricePence: number): number | null {
  const baseline = sessions * unitPence
  if (baseline <= 0) return null
  return Math.round(((baseline - pricePence) / baseline) * 100)
}

export function savingPence(sessions: number, unitPence: number, pricePence: number): number {
  return Math.max(0, sessions * unitPence - pricePence)
}
